module.exports = __webpack_public_path__ + "static/img/materialsInfo31.2c2d877.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/materialsInfo31.png
// module id = 25dF
// module chunks = 2